<template>
  <div class="full-body header" flex fic fjc>
    <div class="w8 mw11 logo-layout" flex fic fjs>
      <a href="/"><img src="/images/upicklogo.webp" alt="" /></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderLayout',
};
</script>